export default async (context, { redirect = false }) => {

    await context.$store.dispatch('auth/setCodeTimestamp', {
        time: new Date().getTime() + (context.waitingPayment * 1000)
    })

    if(redirect) {
        await context.$store.dispatch('auth/setPhone', {
            phone: context.phone
        })
    }

    context.loading = true

    await context.$axios.get(`/phone/${context.phone}`)
        .then(({ data }) => {
            if(data.success) {
                context.overlay = false
                context.error.status = false
                context.error.text = ''
                if (redirect) context.$router.push(redirect)
            } else {
                context.error.text = data.error
                context.overlay = true
                context.error.status = true
            }
        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Ошибка сервера! Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
        })

}